import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { setHeaderTitle } from "stores/slices/layout";

import AddCard from "./addCard";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY
);

const CheckoutForm = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle("addCard"));
  }, []);

  return (
    <>
      <Elements stripe={stripePromise}>
        <AddCard isGoToPayment={true} />
      </Elements>
    </>
  );
};

export default CheckoutForm;
